import { ReactElement, useState } from 'react';
import { Stack } from '@mui/material';
import {
  HasOffersFilter,
  MerchantFilter,
  RegionFilter,
} from '../../../../Components/ReportsWidget/Filters';
import ReportWidget from '../../../../Components/ReportsWidget/Widget';
import type { MerchantsOfferSummariesResource } from '../../../../Entities/MerchantsOfferSummary';
import ExportButton from './ExportButton';
import MerchantsOfferSummaryTable from './MerchantsOfferSummaryTable';
import PreviewButton from './PreviewButton';

export default function MerchantsOfferSummaryWidget(): ReactElement {
  const [hasPreview, setHasPreview] = useState(false);
  const [records, setRecords] = useState<MerchantsOfferSummariesResource[]>([]);

  return (
    <Stack spacing={1}>
      <ReportWidget
        resource="merchants_offer_summaries"
        filters={[RegionFilter, MerchantFilter, HasOffersFilter]}
        defaultValues={{ has_offers: true }}
        actions={
          <>
            <PreviewButton
              onPreviewStart={() => {
                setRecords([]);
                setHasPreview(false);
              }}
              onPreviewSuccess={(records) => {
                setRecords(records);
                setHasPreview(true);
              }}
            />
            <ExportButton />
          </>
        }
      />
      {hasPreview && <MerchantsOfferSummaryTable data={records} />}
    </Stack>
  );
}
